export default __webpack_public_path__ + "static/media/SASC.720f2c51.png";